/**
 *  @class
 *  @function FreeShippingProgressBar
 */

if (!customElements.get('free-shipping-progress-bar')) {
    let currentPercent = 0; // Store the current percentage globally
    class FreeShippingProgressBar extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.updateStatus();
      }
  
      updateStatus() {
        console.log(this.dataset.freegiftAmount);
        const remainingAmountText = this.querySelector('.free-shipping__info-remaining strong');
        const cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
        const freeShippingThreshold = Math.round(parseInt(this.dataset.shippingAmount, 10) * (Shopify.currency.rate || 1));
        const remainingInfo = this.querySelector('.free-shipping__info-remaining');
        const eligibilityInfo = this.querySelector('.free-shipping__info-eligibility');
        const isEligible = cartTotal >= freeShippingThreshold;
  
        if (remainingAmountText && !isEligible) {
          const remainingAmount = freeShippingThreshold - cartTotal;
          var currencyFormat = window.theme.settings.money_with_currency_format || "${{amount}}";
          remainingAmountText.innerHTML = formatMoney(remainingAmount, currencyFormat);
        }
   
        remainingInfo.style.display = isEligible ? 'none' : 'block';
        eligibilityInfo.style.display = isEligible ? 'block' : 'none';
         const progressBar = document.querySelector('free-shipping-progress-bar');
           
          if (progressBar) {
        const remainingProductAmountText = this.querySelector('.free-product__info-remaining strong');
        const freeProductThreshold = Math.round(parseInt(this.dataset.freegiftAmount, 10) * (Shopify.currency.rate || 1));
        const remainingInfo = this.querySelector('.free-shipping__info-remaining');
        const eligibilityInfo = this.querySelector('.free-shipping__info-eligibility');
        const isProductEligible = cartTotal >= freeProductThreshold;
            const total_cart_amount = parseFloat(progressBar.getAttribute('data-cart-total')) || 0;
            const total_freegift_amount = parseFloat(progressBar.getAttribute('data-freegift-amount')) || 0;
            const remainingEl = document.querySelector('.free-product__info-remaining');
            const eligibilityEl = document.querySelector('.free-product__info-eligibility');
          if (remainingProductAmountText && !isProductEligible) {
          const remainingProductAmount = freeProductThreshold - cartTotal;
          var currencyFormat = window.theme.settings.money_with_currency_format || "${{amount}}";
          remainingProductAmountText.innerHTML = formatMoney(remainingProductAmount, currencyFormat);
        }
            if (cartTotal >= freeProductThreshold) {
              console.log('eligibilityEl');
              if (remainingEl) remainingEl.style.display = 'none';
              if (eligibilityEl) eligibilityEl.style.display = 'block';
            } else {
              console.log('remainingEl');
              if (remainingEl) remainingEl.style.display = 'block';
              if (eligibilityEl) eligibilityEl.style.display = 'none';
            }

          }
        const progressPercentage = isEligible ? 1 : cartTotal / freeShippingThreshold;
        this.animateProgressBar(progressPercentage);
      }
  
      animateProgressBar(progressPercentage) {
        const targetPercent = progressPercentage * 100;
        const startPercent = currentPercent;
        const duration = 200;
        const startTime = performance.now();
  
        const ease = (t) => t * (2 - t); 
  
        const animate = (time) => {
          const elapsed = time - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easedProgress = ease(progress);
  
          currentPercent = startPercent + (targetPercent - startPercent) * easedProgress;
          this.style.setProperty('--percent', `${currentPercent}%`);
  
          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            currentPercent = targetPercent; 
            this.style.setProperty('--percent', `${currentPercent}%`);
          }
        };
  
        requestAnimationFrame(animate);
      }
    }
  
    customElements.define('free-shipping-progress-bar', FreeShippingProgressBar);
}